module.exports = __webpack_public_path__ + "img/wps.ed96e1e7.svg";